import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2a7ab8ce&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ab8ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7ab8ce')) {
      api.createRecord('2a7ab8ce', component.options)
    } else {
      api.reload('2a7ab8ce', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2a7ab8ce&scoped=true&", function () {
      api.rerender('2a7ab8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ydrpk9orsoMV/JS/comp/SearchFilterTokens.vue"
export default component.exports